import { type EntranceData } from './load_data'
import { Feature } from 'ol'
import { Point } from 'ol/geom'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style'

export const entranceStyle = new Style({
  image: new Icon({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    src: 'data:image/png;base64,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',
  }),
})

export const generateEntrance = (entranceData: EntranceData | undefined, mapHeight: number) => {
  if (!entranceData) {
    return new VectorLayer()
  }

  const iconFeature = new Feature({
    geometry: new Point([entranceData.imageCoords[0], mapHeight - entranceData.imageCoords[1]]),
    name: 'Въезд',
    type: 'Entrance',
  })

  iconFeature.setStyle(entranceStyle)

  const vectorSource = new VectorSource({
    features: [iconFeature],
  })

  return new VectorLayer({
    source: vectorSource,
  })
}
